import { render, staticRenderFns } from "./LiveEditorDialog.vue?vue&type=template&id=5c871652&scoped=true"
import script from "./LiveEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveEditorDialog.vue?vue&type=style&index=0&id=5c871652&prod&lang=scss&scoped=true"
import style1 from "./LiveEditorDialog.vue?vue&type=style&index=1&id=5c871652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c871652",
  null
  
)

export default component.exports